/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxtE2eV1TestRunEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXT_E2E_V1_TEST_RUN_EVENT_ENTITY_NAME = 'ixt.e2e.v1.TestRunEvent';
export const ixtE2eV1TestRunEventEntity = new schema.Entity<IxtE2eV1TestRunEvent>(IXT_E2E_V1_TEST_RUN_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxtE2eV1TestRunEvent) => `${entity.metadata?.eventId}` });

